import { render, staticRenderFns } from "./BusinessRedeemSettings.vue?vue&type=template&id=12040f87"
import script from "./BusinessRedeemSettings.vue?vue&type=script&lang=js"
export * from "./BusinessRedeemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports